import React from 'react';
import { motion } from 'framer-motion';

const steps = [
    { number: "01", title: "פגישת היכרות", description: "הבנת הצרכים, החלומות והתקציב שלכם." },
    { number: "02", title: "תכנון וקונספט", description: "יצירת סקיצות, הדמיות ובחירת חומרים." },
    { number: "03", title: "תוכניות עבודה", description: "הכנת סט תוכניות מפורט לביצוע." },
    { number: "04", title: "פיקוח וסטיילינג", description: "ליווי בשטח עד למסירת המפתח." }
];

const Process = () => {
    return (
        <section id="process" className="section process-section bg-light">
            <div className="container">
                <h2 className="section-title">תהליך העבודה</h2>
                <div className="process-steps">
                    {steps.map((step, index) => (
                        <motion.div
                            key={index}
                            className="process-step"
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                        >
                            <div className="step-number">{step.number}</div>
                            <h3>{step.title}</h3>
                            <p>{step.description}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Process;
